import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLocale, setLocale } from "./i18nRefs.jsx";
import { dict } from "./i18n";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { SubscribeEmailModal } from "./SubscribeEmailModal";
import { SubscribeNumberModal } from "./SubscribeNumberModal";
import { FaEnvelope, FaSms } from "react-icons/fa";
import { OverlayTrigger, Tooltip, Stack } from "react-bootstrap/";

const Header = (props) => {
  let navigate = useNavigate();
  const [locale, setLocalLocale] = useState(getLocale());
  const [i18n, seti18n] = useState(dict[getLocale()]);
  const [showEmail, setShowEmail] = useState(false);
  const [showSms, setShowSms] = useState(false);
  return (
    <div id="header" className={"header"}>
      <Stack style={styles.headerStack}>
        <div>
          <Nav className="justify-content-end">
            <Nav.Item>
              <Nav.Link
                href={"home"}
                className="text-primary"
                style={props.activeKey === "home" ? styles.activeLink : null}
              >
                {i18n.HOME}
              </Nav.Link>
            </Nav.Item>


            <Nav.Item>
              <Nav.Link
                href={"warnings"}
                style={
                  props.activeKey === "warnings"
                    ? styles.activeLink
                    : null
                }
                className="text-primary"
              >
                {i18n.ISSUED_WARNINGS}
              </Nav.Link>
            </Nav.Item>


            {<Nav.Item>
              {locale === "en_us" ? (
                <Nav.Link
                  style={{ float: "right" }}
                  className={"btn btn-link locale-link"}
                  onClick={() => setLocale("es")}
                >
                  Español
                </Nav.Link>
              ) : (
                <Nav.Link
                  style={{ float: "right" }}
                  className={"btn btn-link locale-link"}
                  onClick={() => setLocale("en_us")}
                >
                  English
                </Nav.Link>
              )}
            </Nav.Item>}
          </Nav>

          <SubscribeEmailModal
            i18n={i18n}
            show={showEmail}
            onClose={() => setShowEmail(false)}
          />
          <SubscribeNumberModal
            i18n={i18n}
            show={showSms}
            onClose={() => setShowSms(false)}
          />
        </div>

        {/* <div
          className="justify-content-center text-center"
          style={{ paddingTop: 20, paddingBottom: 20 }}
        >
          <h1>{i18n.HEADER_TITLE}</h1>
        </div> */}
      </Stack>
    </div>
  );
};

const styles = {
  headerStack: {
    padding: 5,
    backgroundColor: "#efefef",
  },
  activeLink: {
    borderBottom: "2px solid #0d6efd",
  },
};

export default Header;
